import { adminApi } from '../api';

// Profil-Nachbau F-15 Punkt 6 (BAU-GELD.md 3.4; PF-759): Typen und Aufrufe der Anfrage eines Mitglieds nach mehr Kontingent bei der
// Verwaltung der eigenen Firma (backend/src/administration/billing/mehrAnfragen.ts, PF-756). Eigene Datei statt geldApi.ts, damit
// der Lauf nicht auf PF-757a/PF-757b wartet. Keine Antwort nennt einen Betrag.

/** darf: Konto einer Firma der Art MANDANT mit Lizenzplatz, ohne costs.write, nicht in einer Sicht; sonst grund. offen: die eigene
 *  offene Anfrage mit Zeitpunkt (ISO) und Begründung. */
export type MeineAnfrage = { darf: boolean; grund?: string; offen: { id: string; am: string; text: string | null } | null };
export const MEHR_ANFRAGE_WEGE = { meine: '/billing/kontingent-anfragen/meine', anfragen: '/billing/kontingent-anfragen' } as const;
/** POST /billing/kontingent-anfragen: eine offene Anfrage wird aktualisiert (neu: false), der Text ersetzt den bisherigen.
 *  Fehler 403 ANFRAGE_NICHT_MOEGLICH und 409 ANFRAGEN_GRENZE mit dem Satz des Servers. */
export const anfrageSenden = (text: string) => adminApi.post<{ id: string; neu: boolean }>(MEHR_ANFRAGE_WEGE.anfragen, { text });
